import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { request, handleErrors } from "../../../services/helpers";

export default function RespondentsDialog({
  open,
  handleClose,
  eventId,
  eventName,
  num_attendees,
}) {
  const [rsvps, setRsvps] = useState([]);

  const fetchRsvps = async () => {
    try {
      const res = await request.get(`/event/rsvp-list/${eventId}`);
      setRsvps(res.data);
      return true;
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    if (eventId) {
      fetchRsvps();
    }
  }, [eventId]);

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <div className="py-8 px-8">
          <button onClick={handleClose} className="font-bold">
            <CloseIcon /> CLOSE
          </button>
        </div>
        <div className="px-8">
          <div className="text-4xl font-rubik font-bold leading-10">
            <h1>{eventName}</h1>
          </div>
        </div>
        <div className="px-8 pt-8 flex justify-between">
          <div className="text-md font-rubik">
            <h4>Respondents</h4>
          </div>
          <div className="text-md font-rubik">
            <h4>{num_attendees}</h4>
          </div>
        </div>
        <div className="px-8 pt-2">
          <hr className="w-full border-black bg-black" />
        </div>
        <div className="px-8 py-4">
          {rsvps.map((l, i) => (
            <div key={i} className="flex justify-between">
              <ListItemAvatar>
                <Avatar
                  alt="Remy Sharp"
                  src={l && l.userId && l.userId.userProfilePic.mini}
                />
              </ListItemAvatar>
              <div className="py-2">
                <h4>{l && l.userId && l.userId.name}</h4>
              </div>
              <div className="py-2">
                <p className="text-gray-500">
                  {l &&
                    l.userId &&
                    l.userId.companyDetails &&
                    l.userId.companyDetails[0].companyName}
                </p>
              </div>
            </div>
          ))}
        </div>
      </Dialog>
    </div>
  );
}
